import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { type DriverMvrState, pulledLabel } from '../../models/mvr'

/** A big fleet would push the buttons off screen; the count carries the point. */
const MAX_LISTED = 8

interface ConfirmRepullDialogProps {
  drivers: DriverMvrState[]
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  pending: boolean
}

export function ConfirmRepullDialog({
  drivers,
  open,
  onOpenChange,
  onConfirm,
  pending,
}: ConfirmRepullDialogProps) {
  const listed = drivers.slice(0, MAX_LISTED)
  const more = drivers.length - listed.length

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>
            {drivers.length === 1
              ? 'This driver already has a recent MVR'
              : 'These drivers already have a recent MVR'}
          </DialogTitle>
          <DialogDescription>Each pull is billed again. Request anyway?</DialogDescription>
        </DialogHeader>
        <ul className="text-sm">
          {listed.map((driver) => (
            <li key={driver.driverId} className="flex items-baseline justify-between gap-4 py-1">
              <span className="font-medium">{driver.name}</span>
              <span className="text-muted-foreground">pulled {pulledLabel(driver)}</span>
            </li>
          ))}
        </ul>
        {more > 0 && (
          <p className="text-muted-foreground text-xs">
            and {more} more {more === 1 ? 'driver' : 'drivers'} with a recent MVR
          </p>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={pending}>
            Back
          </Button>
          <Button onClick={onConfirm} loading={pending ? 'Requesting…' : undefined}>
            Pull again
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
